<template>
    <div v-if="dataLoaded">
        <h3 class="mb-4">Encuestas/Quices</h3>

        <b-tabs
            active-nav-item-class="bg-primary text-white"
            v-if="surveys && (surveys.survey.length || surveys.quiz.length)"
        >
            <!-- Surveys tab -->
            <b-tab
                v-if="surveys.survey.length"
                title="Encuestas"
            >
                <b-table
                    hover
                    responsive
                    striped
                    :items="surveys.survey"
                    :fields="surveysFields"
                    :sort-by="'name'"
                    :sort-desc="false"
                >
                    <template v-slot:cell(name)="data">
                        <router-link
                            v-if="canGoToDetailPage(data.item)"
                            :to="{ name: 'site-student-surveys-detail', params: { surveyId: data.item.id } }"
                        >
                            {{ data.value }}
                        </router-link>
                        <span v-else>{{ data.value }}</span>
                    </template>

                    <template v-slot:cell(durationMinutes)="data">
                        <span v-if="data.value === 0">Indefinida</span>
                        <span v-else>{{ data.value }} mins.</span>
                    </template>

                    <template v-slot:cell(completed)="data">
                        <span v-if="data.item.studentSurvey.completedAt !== null">Si</span>
                        <span v-else>No</span>
                    </template>
                </b-table>
            </b-tab>

            <!-- Quizzes tab -->
            <b-tab
                v-if="surveys.quiz.length"
                title="Quices"
            >
                <b-table
                    hover
                    responsive
                    striped
                    :items="surveys.quiz"
                    :fields="quizFields"
                    :sort-by="'name'"
                    :sort-desc="false"
                >
                    <template v-slot:cell(name)="data">
                        <router-link
                            v-if="canGoToDetailPage(data.item)"
                            :to="{ name: 'site-student-surveys-detail', params: { surveyId: data.item.id } }"
                        >
                            {{ data.value }}
                        </router-link>
                        <span v-else>{{ data.value }}</span>
                    </template>

                    <template v-slot:cell(durationMinutes)="data">
                        <span v-if="data.value === 0">Indefinida</span>
                        <span v-else>{{ data.value }} mins.</span>
                    </template>

                    <template v-slot:cell(completed)="data">
                        <span v-if="data.item.studentSurvey.completedAt !== null">Si</span>
                        <span v-else>No</span>
                    </template>

                    <template v-slot:cell(totalValue)="data">
                        <span v-if="data.item.studentSurvey.completedAt !== null">{{ data.item.studentSurvey.totalValue }} %</span>
                        <span v-else>-</span>
                    </template>
                </b-table>
            </b-tab>
        </b-tabs>
        <p v-else>No es participante de ninguna encuesta o quiz para este sitio web.</p>

    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'StudentsSurveysList',
    data () {
        return {
            dataLoaded: false,
            surveyTypes: {
                survey: 'Encuestas',
                quiz: 'Quices'
            }
        }
    },
    computed: {
        ...mapState({
            activeSite: 'activeSite',
            surveys: 'activeSiteStudentSurveys'
        }),
        ...mapGetters([
            'isUserStudentOrBetter'
        ]),
        surveysFields () {
            return [
                { key: 'name', label: 'Nombre', sortable: true },
                { key: 'durationMinutes', label: 'Duración', class: 'text-center' },
                { key: 'completed', label: 'Completo', class: 'text-center' }
            ]
        },
        quizFields () {
            return [
                { key: 'name', label: 'Nombre', sortable: true },
                { key: 'durationMinutes', label: 'Duración', class: 'text-center' },
                { key: 'completed', label: 'Completo', class: 'text-center' },
                { key: 'totalValue', label: 'Puntaje', class: 'text-center' }
            ]
        }
    },
    methods: {
        ...mapActions([
            'readSiteStudentSurveys'
        ]),
        async loadSiteSurveys () {
            let loader = this.$loading.show()
            this.dataLoaded = false
            try {
                await this.readSiteStudentSurveys(this.activeSite.id)
                this.dataLoaded = true
            } catch (err) {
                console.log(err)
                this.dataLoaded = false
                this.unknownErrorToast()
            } finally {
                loader.hide()
            }
        },
        canGoToDetailPage (survey) {
            if (
                survey.studentSurvey.completedAt === null ||
                (survey.studentSurvey.completedAt !== null && survey.showAnswers && survey.isEvaluated)
            ) {
                return true
            }
            return false
        }
    },
    async created () {
        this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
        await this.loadSiteSurveys()
    },
    async destroyed () {
        this.$store.commit('RESET_ACTIVE_SITE_SURVEYS')
    }
}
</script>
